export default __webpack_public_path__ + "static/media/microvessel-model-1mm2mm.74ccf344.png";